import type { Assessment } from "../assessment-types";

export const BOUNDARIES_ASSESSMENT: Assessment = {
  slug: "boundaries",
  emoji: "🚪",
  title: "Boundaries",
  tagline: "How easy is it to hold your own limits?",
  intro:
    "This reflects on how comfortable it feels to set and keep boundaries with other people. There are no right answers, just patterns worth noticing.",
  questions: [
    { id: "q1", text: "Do you find it hard to say no, even when you want to?" },
    { id: "q2", text: "Do you feel guilty after turning down a request?" },
    { id: "q3", text: "Do you let people cross a line with you because you don't want a confrontation?" },
    { id: "q4", text: "Do you find yourself agreeing to plans you don't actually want to do?" },
    { id: "q5", text: "Do you struggle to speak up when someone treats you unfairly?" },
    { id: "q6", text: "Do you feel drained from giving more time or energy than you have to spare?" },
    { id: "q7", text: "Do you avoid asking for space or time alone, even when you need it?" },
    { id: "q8", text: "Do you find yourself taking on other people's problems as your own?" },
    { id: "q9", text: "Do you worry that setting a limit will make someone think badly of you?" },
    { id: "q10", text: "Do you find it hard to end conversations or interactions that feel draining?" },
    { id: "q11", text: "Do you go along with things that don't sit right with you to avoid a difficult moment?" },
    { id: "q12", text: "Do you notice resentment building because you've said yes too often?" },
  ],
  bands: [
    {
      key: "low",
      minPercent: 0,
      headline: "Your answers suggest holding boundaries feels manageable for you right now.",
      body:
        "It sounds like you're generally able to voice your limits without too much difficulty. It's still worth noticing the situations where this feels harder.",
    },
    {
      key: "some",
      minPercent: 30,
      headline: "You may recognise some patterns of finding boundaries difficult to hold.",
      body:
        "Setting limits can feel uncomfortable for lots of people, especially in close relationships. Noticing the moments it feels harder is a useful starting point.",
    },
    {
      key: "often",
      minPercent: 55,
      headline: "Your answers suggest you may often find it hard to set or hold boundaries.",
      body:
        "This can develop when saying no once felt unsafe or unwelcome. It made sense as a way of keeping relationships steady, even though it can leave you feeling stretched thin.",
    },
    {
      key: "high",
      minPercent: 78,
      headline: "Your answers suggest holding boundaries may feel strongly and consistently difficult.",
      body:
        "Constantly putting your own limits aside can be exhausting and can build quiet resentment over time. This pattern usually has an understandable history, and small steps can help it shift.",
    },
  ],
  next: [
    { label: "Explore people-pleasing", to: "/learn/people-pleasing" },
    { label: "Understand trauma responses", to: "/learn/trauma-responses" },
    { label: "Explore trauma and relationships", to: "/learn/trauma-relationships" },
    { label: "Try a check-in", to: "/check-in" },
  ],
};
